// src/lib/wp.js
const RAW_BASE = process.env.REACT_APP_WP_API_BASE || "";
export const WP_API_BASE = RAW_BASE.replace(/\/+$/, ""); // sondaki / temizle

export function wp(path = "") {
  const p = String(path);
  return p.startsWith("/") ? `${WP_API_BASE}${p}` : `${WP_API_BASE}/${p}`;
}
